import React from 'react';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { connect } from 'react-redux';
import { ClubParams } from './club.new.validate';
import ClubNewForm from './club.new.form';
import { Club } from '@Models';

interface ClubNewProps {
  club: Club,
  cancel: () => void,
  handleSubmit: (values: ClubParams) => void,
}

const ClubNew: React.FC<Props> = ({
                                    cancel,
                                    club,
                                    handleSubmit
                                  }) => {
  return (
    <div className="mt-2">
      <ClubNewForm cancel={cancel} club={club} onSubmit={handleSubmit} canSubmit={true} />
    </div>
  );
};


const mapStateToProps = (state: AppState, props: ClubNewProps) => ({
  club: props.club,
  cancel: props.cancel,
  handleSubmit: props.handleSubmit
});

const mapDispatchToProps = (dispatch: Dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ClubNew);

type Props = ClubNewProps &
  ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>;
